import { SET_CATEGORIES, SET_CATEGORY_DATA_LOADING, SET_SEARCH_CATEGORY_BY_ID } from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const getCategories = (params) => async (dispatch) => {
  try {
    dispatch({ type: SET_CATEGORY_DATA_LOADING });
    const companyId = store.getState().authState.companyId;

    const queryParams = {
      ...params,
      companyId,
    };

    const res = await Axios.get(`/api/dashboard/categories/find-all`, {
      params: queryParams,
    });

    dispatch({
      type: SET_CATEGORIES,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: SET_CATEGORIES,
      payload: [],
    });
  }
};

export const createCategory = (category) => async (dispatch) => {
  try {
    dispatch({
      type: SET_CATEGORY_DATA_LOADING,
      payload: true
    });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const requestBody = {
      ...category,
      companyId,
    };

    const queryParams = {
      companyId,
      branchId,
    };

    const res = await Axios.post(`/api/dashboard/categories`, requestBody, {
      params: queryParams,
    });

    dispatch({
      type: SET_CATEGORY_DATA_LOADING,
      payload: false,
    });

    return true;
  } catch (error) {
    return false;
  }
};

export const getCategoryById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: SET_CATEGORY_DATA_LOADING,
      payload: true
    });

    const res = await Axios.get(`/api/dashboard/categories/find-by-id`, {
      params: { id },
    });

    dispatch({
      type: SET_SEARCH_CATEGORY_BY_ID,
      payload: res.data.data,
    });
  } catch (error) {
    dispatch({
      type: SET_SEARCH_CATEGORY_BY_ID,
      payload: [],
    });
  }
};

export const updateCategory = (id, requestBody) => async (dispatch) => {
  try {
    dispatch({
      type: SET_CATEGORY_DATA_LOADING,
      payload: true
    });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const queryParams = {
      companyId,
      branchId,
    };

    const res = await Axios.put(`/api/dashboard/categories/${id}`, requestBody, {
      params: queryParams,
    });

    dispatch({
      type: SET_CATEGORY_DATA_LOADING,
      payload: false,
    });

    return true;
  } catch (error) {
    return false;
  }
};